import { useNextRouterContext } from "@faire/deprecated-retailer-visitor-shared/app/_lib/routing/NextRouterContext";
import { LeanBrandTileRendererForCarouselBase } from "@faire/deprecated-retailer-visitor-shared/components/LeanBrandTileRenderer/__internal__/LeanBrandTileRendererForCarouselBase";
import { brandPage } from "@faire/deprecated-retailer-visitor-shared/paths/index";
import { useSettingBrandLinkHoverThreshold } from "@faire/deprecated-retailer-visitor-shared/settings/getSettingBrandLinkHoverTheshold";
import { useSettingBrandPageAggressivePrefetchingThreshold } from "@faire/deprecated-retailer-visitor-shared/settings/getSettingBrandPageAggressivePrefetchingThreshold";
import { useSettingBrandPageAggressivePrefetching } from "@faire/deprecated-retailer-visitor-shared/settings/useSetttingBrandPageAggressivePrefetching";
import { Column } from "@faire/web/slate/Layout";
import { PrefetchKind } from "next/dist/client/components/router-reducer/router-reducer-types";
import * as React from "react";

import { BrandTileProps } from "./BrandTileProps";

export const LeanBrandTileRendererForCarousel: React.FC<BrandTileProps> = (
  props
) => {
  const token = props.brandTile?.brand?.token;
  const shortPrefetchDelay =
    useSettingBrandPageAggressivePrefetchingThreshold();
  const longPrefetchDelay = useSettingBrandLinkHoverThreshold();
  const PREFETCH_DELAY_MS = useSettingBrandPageAggressivePrefetching()
    ? shortPrefetchDelay
    : longPrefetchDelay;
  const timeoutRef = React.useRef<ReturnType<typeof setTimeout> | undefined>(
    undefined
  );
  const { prefetch: nextPrefetch } = useNextRouterContext();

  const handleClick = () => {
    clearTimeout(timeoutRef.current);
    if (props.onClick && token) {
      props.onClick(token);
    }
  };
  const handleFocus = () => {
    timeoutRef.current = setTimeout(() => {
      if (token) {
        nextPrefetch(brandPage(token), {
          kind: PrefetchKind.FULL,
        });
      }
    }, PREFETCH_DELAY_MS);
  };
  const handleBlur = () => {
    clearTimeout(timeoutRef.current);
  };

  return (
    <Column
      style={{ height: "100%" }}
      data-test-id={`lean-brand-tile-renderer-onclick-container-${token}`}
      onClick={handleClick}
      onMouseEnter={handleFocus}
      onMouseLeave={handleBlur}
      onFocus={handleFocus}
      onBlur={handleBlur}
      onTouchStart={handleFocus}
    >
      <LeanBrandTileRendererForCarouselBase {...props} />
    </Column>
  );
};
